<!-- <p>data-integrations-neuronsensors works!</p> -->
<div style="padding: 20px;">
	<table>
		<colgroup>
			<col style="width: 150px;">
			<col style="width: auto;">
			<col style="width: auto;">
		</colgroup>
		<tbody>
			<ng-container *ngIf="NeuronSystem then nsSystem else noSystem"></ng-container>
		</tbody>
	</table>
	<table>
		<colgroup>
			<col style="width: 150px;">
			<col style="width: 30px;">
			<col style="width: auto;">
		</colgroup>
		<tbody>
			<ng-container *ngIf="NeuronWebhook then nsWebhook else noWebhook"></ng-container>
		</tbody>
	</table>

</div>

<!-- <div style="padding: 20px;" *ngIf="false">
	<div><b>Note:</b></div>
	<div><span>Make sure that the <b>OrganisationUID </b> has been added to the Headers in the Neuron Webhook
			Configuration</span></div>
	<div>
		<img [src]="'https://stmgwebappstorage.blob.core.windows.net/prismpdm/webhooks/ElWatchWebhookHeaders.png'"
			appImageOnErrorFallback />
	</div>
</div> -->

<ng-template #nsSystem>
	<tr>
		<td rowspan="3" style="text-align: left;">
			<img src="{{NeuronSystem.image}}" alt="{{NeuronSystem.name}}" style="height: 100px; width: 100px;"
				onerror="this.src='https://stmgwebappstorage.blob.core.windows.net/prismpdm/assets/noimage.png'" />
		</td>
		<th>Neuron Sensor System:</th>
		<td>{{NeuronSystem.name}}</td>		
	</tr>
	<tr>
		<th style="vertical-align: top;" >System Description:</th>
		<td style="vertical-align: top;">{{NeuronSystem.description}}</td>
	</tr>	
	<tr>
		<td colspan="2" style="text-align: left;" *ngIf="NeuronWebhook">
			<button mat-raised-button color="primary" (click)="goToSystem()"
				title="Go to NeuronSensors"><span>View System</span></button>
			<button mat-raised-button color="primary" (click)="goToSystem('integrations')" style="margin-left: 1em;"
				title="Go to NeuronSensors"><span>View Integration</span></button>
		</td>
	</tr>
</ng-template>

<ng-template #noSystem>
	<tr>
		<th colspan="2">System:</th>
		<td>Undefined</td>
	</tr>
</ng-template>

<ng-template #nsWebhook>
	<tr>
		<th>Webhook Name:</th>
		<td>
			<mat-icon style="color: green;"
				*ngIf="NeuronWebhook.name.includes(webhookIntegration.WebhookUID)">verified</mat-icon>
		</td>
		<td>{{NeuronWebhook.name}}</td>
	</tr>
	<tr>
		<th class="alignRow">
			<span>Webhook endpoint:</span>
		</th>
		<td>
			<mat-icon style="color: green;"
				*ngIf="NeuronWebhook.endpoint.trim().toLowerCase() == webhookIntegration.FQN.trim().toLowerCase()">verified</mat-icon>
		</td>
		<td>{{NeuronWebhook.endpoint}}</td>
	</tr>

	<ng-container *ngIf="NeuronWebhookHeaders then nsHeaders"></ng-container>

	<tr>
		<th colspan="2">Webhook Status:</th>
		<!-- <td [ngClass]="NeuronWebhook.disabled > 0 ? 'text-red' : 'text-green'" class="alignRow"> -->
		<td>
			<!-- {{NeuronWebhook.disabled > 0 ? 'Disabled' : 'Enabled'}}
			<mat-icon>{{NeuronWebhook.disabled > 0 ? 'toggle_off' : 'toggle_on'}}</mat-icon>
			(Value:{{NeuronWebhook.disabled}}) -->
			<span [ngSwitch]="NeuronWebhook.disabled" class="alignRow">
				<mat-slide-toggle #switchWebhookEnabled [checked]="NeuronWebhook.disabled < 100"
					color="primary" (mousedown)="nsEnable($event)">
				</mat-slide-toggle>
				<span style="color: green;"
					*ngIf="NeuronWebhook.disabled == 0">&nbsp;(Enabled)</span>
				<span style="color: gold;" *ngIf="NeuronWebhook.disabled > 0 && 
					NeuronWebhook.disabled < 100">&nbsp;(Warning)</span>
				<span style="color: red;"
					*ngIf="NeuronWebhook.disabled >= 100">&nbsp;(Disabled)</span>
					{{NeuronWebhook.disabled}}
			</span>
		</td>


		
	</tr>

</ng-template>

<ng-template #noWebhook>
	<tr>
		<th colspan="2">Webhook:</th>
		<td>Undefined</td>
	</tr>
</ng-template>

<ng-template #nsHeaders>
	<tr>
		<th>HTTP Header Values</th>
		<td>&nbsp;</td>
		<td>&nbsp;</td>
	</tr>
	<tr *ngFor="let header of NeuronWebhookHeaders">
		<th class="alignRow">
			<span>{{header[0]}}</span>
		</th>
		<td *ngIf="webhookIntegration">
			<mat-icon style="color: green;"
				*ngIf="header[0] == 'OrganisationUID' && header[1] == webhookIntegration.OrganisationUID">verified</mat-icon>
			<mat-icon style="color: green;"
				*ngIf="header[0] == 'AccountUID' && header[1] == selectedAccountGUID">verified</mat-icon>
			<mat-icon style="color: green;"
				*ngIf="header[0] == 'Content-Type' && header[1] == 'application/json'">verified</mat-icon>
			<mat-icon style="color: green;"
				*ngIf="header[0] == 'ClientWebhookID' && header[1] == webhookIntegration.ClientWebhookID">verified</mat-icon>
		</td>
		<td><span>{{header[1]}}</span></td>
	</tr>
</ng-template>